__turbopack_context__.v({
  "image": "styles-module-scss-module__JZyqPa__image",
  "root": "styles-module-scss-module__JZyqPa__root",
});
